import React from 'react';
import * as Styled from './Steps.styled';
import Step from './Step';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import { useInputData } from './hooks/useInputData';
import { checkPlayerId } from '../../../logoMakerApi';
import Download from '../Download/Download';
import Input from '../InputRaidId/Input';
import DownloadLogo from '../DownloadLogo/DownloadLogo';
import { LOGO_MAKER_STORAGE_IMAGE } from '../../../logoMakerState/constants';

const Steps: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [isSubmitButtonDisabled, setSubmitButtonDisabled] = React.useState(true);
  const { input, validate, errors, setErrorsFromServer } = useInputData();

  const downloadThankYouWidget = useWidget(WidgetId.LogoMakerThankYouRaidIdV3);

  React.useEffect(() => {
    setSubmitButtonDisabled(input.userId === '' || input.error !== '');
  }, [input.userId, input.error]);

  const downloadLogo = () => {
    const logoMakerImageRaw = window.localStorage.getItem(LOGO_MAKER_STORAGE_IMAGE);
    if (logoMakerImageRaw) {
      const logoMakerState = JSON.parse(logoMakerImageRaw);
      const a = document.createElement('a');
      document.body.append(a);
      a.download = 'logo';
      a.href = logoMakerState;
      a.click();
      a.remove();
    }

    window.location.href = downloadThankYouWidget.links.redirectUrl;
  };

  const handleOnSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }

    try {
      setIsSubmitting(true);

      validate({ playerId: input.userId })
        .then(() => {
          setSubmitButtonDisabled(false);
          return checkPlayerId(input.userId)
            .then((result) => {
              console.log(`checkPlayerId result= ${JSON.stringify(result)}`);
              downloadLogo();
              setSubmitButtonDisabled(true);
            })
            .catch((activateError) => {
              setErrorsFromServer(activateError);
            });
        })
        .finally(() => setIsSubmitting(false));
    } catch (error) {
      setErrorsFromServer(error);
      setIsSubmitting(false);
    }
  };

  return (
    <Styled.FormElement onSubmit={handleOnSubmit}>
      <Styled.Wrapper>
        <Step step={1} title={downloadThankYouWidget.strings.firstStep}>
          <Download />
        </Step>
        <Step step={2} title={downloadThankYouWidget.strings.secondStep}>
          <Input input={input} />
          {errors?.playerId && <Styled.Error>{errors.playerId}</Styled.Error>}
        </Step>
        <Step step={3} title={downloadThankYouWidget.strings.thirdStep}>
          <DownloadLogo isActionDisabled={isSubmitButtonDisabled} />
        </Step>
        <Styled.GreenLineWrapper>
          <Styled.GreenLine />
        </Styled.GreenLineWrapper>
      </Styled.Wrapper>
    </Styled.FormElement>
  );
};

export default Steps;
